import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {Button, Card, Form, Input, notification} from "antd";
import {changePassword} from "./actions";
import {formItemLayout} from "../utils/style";
import {handleFormErrorNotification} from "../utils/errors";

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class LogoutPage extends Component {
  componentDidMount() {
  }

  handleConfirmPassword = (rule, value, callback) => {
    const {getFieldValue} = this.props.form;
    if (value && value !== getFieldValue('password')) {
      callback('Both password must be the same');
    }
    callback();
  };

  goBack = () => {
    this.props.history.push("/");
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const {form: {setFields}} = this.props;
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.changePassword(values);
        notification.success({
          message: 'Password changed',
          description: `You'll need to use your new password the next time you log in`
        });
        this.goBack();
      } catch (err) {
        handleFormErrorNotification(err, values, setFields, notification);
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    return <Card title="Change password">
      <Form>
        <Form.Item label="Current password" {...formItemLayout}>
          {getFieldDecorator('oldPassword', {
            initialValue: '',
            rules: [
              {required: true}
            ]
          })(
            <Input autoFocus type="password"/>
          )}
        </Form.Item>
        <Form.Item label="New password" {...formItemLayout}>
          {getFieldDecorator('password', {
            initialValue: '',
            rules: [
              {required: true, min: 8}
            ]
          })(
            <Input type="password"/>
          )}
        </Form.Item>
        <Form.Item label="Confirm new password" {...formItemLayout}>
          {getFieldDecorator('confirmPassword', {
            initialValue: '',
            rules: [
              {required: true, min: 8},
              {validator: this.handleConfirmPassword},
            ]
          })(
            <Input type="password"/>
          )}
        </Form.Item>
        <Form.Item>
          <Button.Group>
            <Button
              type="primary"
              htmlType="button"
              onClick={this.handleSubmit}
              disabled={loading || hasErrors(getFieldsError())}
            >
              Change Password
            </Button>
            <Button
              htmlType="button"
              onClick={this.goBack}
            >
              Cancel
            </Button>
          </Button.Group>
        </Form.Item>
      </Form>
    </Card>;
  }
}

LogoutPage.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  changePassword: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  loading: state.user.changingPassword,
});
const mapDispatchToProps = dispatch => ({
  changePassword: bindActionCreators(changePassword, dispatch),
});

const LogoutPageForm = Form.create()(LogoutPage);

export default connect(mapStateToProps, mapDispatchToProps)(LogoutPageForm);



// WEBPACK FOOTER //
// ./src/User/ChangePasswordPage.js